"use client";

import { onMessageListener, requestForToken, requestPermissionAndToken } from "@lib/firebase";
import { useEffect } from "react";
import showOrderToast from "@components/toast/show-toast";
import { useCreateFirebaseMutation } from "@framework/firebase/firebase.mutation";

export function FirebaseNotification() {
//     const { mutate: createFirebase } = useCreateFirebaseMutation();
//     useEffect(() => {
//         requestPermissionAndToken().then((token) => {
//             if (token) {
//                 createFirebase({input: token })
//             }
//         });
//         onMessageListener((payload: any) => {

//             const data = payload?.data;
            
//             if (!data) return;
//             showOrderToast(data);
//         });
//   }, []);

  return null;
}
